module.exports = "/assets/66cab82579558dc2eb3ac574da69d099.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/K5.png
// module id = 1533
// module chunks = 0